import React from 'react';
import { APP_COLORS as C, APP_FONT as F } from '../tokens';
import ProfitLossCard from './ProfitLossCard';
import ExpensesDonutCard from './ExpensesDonutCard';
import BankAccountsCard from './BankAccountsCard';
import type { ProfitLoss, ExpenseCategory, BankAccount } from '../types';

type Props = {
  profitLoss: ProfitLoss;
  expenseCategories: ReadonlyArray<ExpenseCategory>;
  expensesTotal: number;
  expensesDeltaPct: number;
  bankAccounts: ReadonlyArray<BankAccount>;
  totalBankBalance: number;
  onViewPL?: () => void;
  onViewExpenses?: () => void;
  onGoToRegisters?: () => void;
  onHelpful?: (card: 'pl' | 'expenses' | 'bank', helpful: boolean) => void;
};

export default function BusinessGlance({
  profitLoss,
  expenseCategories,
  expensesTotal,
  expensesDeltaPct,
  bankAccounts,
  totalBankBalance,
  onViewPL,
  onViewExpenses,
  onGoToRegisters,
  onHelpful,
}: Props) {
  return (
    <section style={{ marginBottom: 24, fontFamily: F.family }}>
      <h2 style={{ fontSize: 16, fontWeight: 700, color: C.ink, margin: '0 0 14px' }}>
        Business at a glance
      </h2>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 18,
      }}>
        <ProfitLossCard
          data={profitLoss}
          onViewDetail={onViewPL}
          onHelpful={(h) => onHelpful?.('pl', h)}
        />
        <ExpensesDonutCard
          categories={expenseCategories}
          total={expensesTotal}
          deltaPct={expensesDeltaPct}
          onViewDetail={onViewExpenses}
          onHelpful={(h) => onHelpful?.('expenses', h)}
        />
        <BankAccountsCard
          accounts={bankAccounts}
          totalBalance={totalBankBalance}
          onGoToRegisters={onGoToRegisters}
          onHelpful={(h) => onHelpful?.('bank', h)}
        />
      </div>
    </section>
  );
}
